import React from 'react';
import {Modal} from 'antd-mobile';
import './index.less';
const DfModal = (props) =>
  /**
   * className: string
   * show: true/false.
   * img: image,
   * desc: string
   * left:{text:string,action: func }
   * right:{text:string,action: func }
   */
  <div>
    <Modal
      visible={props.show}
      transparent
      maskClosable
      onClose={() => { props.close&&props.close();}}
      title=" "
      className="del-order-modal"
    >
      <div className="content">
        {props?.img?<img src={props.img} alt="" />:null}
        <p>{props.desc}</p>
        <div className="footer">
          <div className="cancle" onClick={() => props.left.action()}>{props.left.text}</div>
          <div className="confirm" onClick={() => { props.right.action(); }}>{props.right.text}</div>
        </div>
      </div>
    </Modal>

  </div>
;
export default DfModal;
